(() => {
  if (window.ecidaHeaderLocalizationReady) return;
  window.ecidaHeaderLocalizationReady = true;

  const detailsSelector = "[data-ecida-localization-details]";

  function closeDetails(exceptDetails) {
    document.querySelectorAll(`${detailsSelector}[open]`).forEach((details) => {
      if (details !== exceptDetails) details.removeAttribute("open");
    });
  }

  document.addEventListener("click", (event) => {
    const currentDetails = event.target.closest(detailsSelector);
    closeDetails(currentDetails);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeDetails();
  });
})();
